import { Loader2 } from 'lucide-react';
import { FormattedMessage } from 'react-intl';

import { PlaneSendIcon } from '@/components/icons/plane-send';
import { Button } from '@/components/ui/button';
import { Typography } from '@/components/ui/typography';
import { useJobPostingContext } from '@/contexts/job-posting-context';
import { useCurrencySymbol } from '@/hooks/use-currency-symbol';
import { POOL } from '@/types/channels';

import { Agreement } from './agreement';
import { ChannelSummaryItem } from './channel-summary-item';

export function Summary() {
  const { formatCurrency } = useCurrencySymbol();
  const { hookForm, totalBudget, isSubmitting } = useJobPostingContext();
  const { getValues } = hookForm;
  const formData = getValues();
  const { pool } = formData;

  return (
    <div className="border-fx-neutral-200 mb-2 flex w-[420px] flex-col items-start gap-6 rounded-lg border bg-white py-6 px-12 shadow-sm">
      <Typography variant="h4">
        <FormattedMessage
          defaultMessage="Post"
          description="Job posting summary title"
        />
      </Typography>

      <div className="bg-fx-neutral-200 h-px w-full" />

      {Object.entries(formData.channels).map(([channelSlug, channelData]) => (
        <ChannelSummaryItem
          key={channelSlug}
          channelSlug={channelSlug}
          startsAt={channelData.startsAt}
          endAt={channelData.endAt}
          totalChannelBudget={channelData.totalChannelBudget}
        />
      ))}

      {pool && (
        <ChannelSummaryItem
          channelSlug={POOL}
          startsAt={pool.startsAt}
          endAt={pool.endAt}
          totalChannelBudget={0}
        />
      )}

      <div className="bg-fx-neutral-200 h-px w-full" />

      <div className="flex w-full items-center justify-between gap-4">
        <Typography variant="body2" className="!text-fx-neutral-600">
          <FormattedMessage
            defaultMessage="Total"
            description="Total budget for all channels"
          />
        </Typography>
        <Typography variant="h4" className="!text-fx-neutral-600">
          {totalBudget ? formatCurrency(totalBudget) : '-'}
        </Typography>
      </div>

      {totalBudget > 0 && (
        <Typography variant="body1" className="mx-auto italic">
          <FormattedMessage
            defaultMessage="This amount will be paid via invoice"
            description="Invoice payment disclaimer"
          />
        </Typography>
      )}

      <Button type="submit" className="mx-auto" disabled={isSubmitting}>
        {isSubmitting ? (
          <Loader2 className="animate-spin" />
        ) : (
          <PlaneSendIcon className="text-white" />
        )}
        <FormattedMessage
          defaultMessage="Post Job"
          description="Button to post the campaign"
        />
      </Button>

      <Agreement />
    </div>
  );
}
